import { render, staticRenderFns } from "./MetricsIcon.vue?vue&type=template&id=1c21b80c&scoped=true"
import script from "./MetricsIcon.vue?vue&type=script&lang=js"
export * from "./MetricsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21b80c",
  null
  
)

export default component.exports